import * as React from 'react';
import {
  MasonrySectionHeaderRenderer,
  MasonrySectionHeaderRendererProps,
} from '@leagueplatform/masonry-renderers';

export const NODE_TYPE_SECTION_HEADER = 'sectionHeader';

export const SectionHeaderRenderer = (
  props: MasonrySectionHeaderRendererProps,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <MasonrySectionHeaderRenderer {...props} paddingTop="$none" />;
